import { QuickRepliesWidget } from "../../../Helper/ChatWidget";
import { ChatWidgetAnswer } from "../ChatWidgetPrimitives";
import "./QuickRepliesCard.scss";

/**
 * 01 Quick replies: outlined pills on the customer's side of the thread.
 * Once tapped they go away (ChatWidget renders nothing for an answered card):
 * the customer's message right below already shows the choice.
 */
export const QuickRepliesCard = ({
  widget,
  onAnswer,
}: {
  widget: QuickRepliesWidget;
  onAnswer: ChatWidgetAnswer;
}) => (
  <div className="cw-qr" role="group" aria-label={widget.title}>
    {(widget.options ?? []).map((option) => (
      <button
        type="button"
        key={option.id}
        className="cw-qr-pill"
        onClick={() =>
          onAnswer("select", { selected: [option.id] }, option.label)
        }
      >
        {option.label}
      </button>
    ))}
  </div>
);
